import { render, staticRenderFns } from "./SectionEditPage.vue?vue&type=template&id=19204d7d&"
import script from "./SectionEditPage.vue?vue&type=script&lang=ts&"
export * from "./SectionEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports